import { useEffect } from 'react';

/**
 * Prefer the device's real landscape orientation for phones only, not only
 * the table itself — the win celebration and waiting room are part of the
 * game too. Tablets have enough room for their native orientation and locking
 * them makes a capable, two-column layout collapse into the phone board.
 *
 * Installed/fullscreen browsers may honour Orientation Lock. A normal mobile
 * tab cannot rotate the browser itself, so it keeps a genuine portrait board
 * rather than rotating just the page into the browser's portrait viewport.
 */
export function useForceLandscape(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const phone = window.matchMedia('(pointer: coarse) and (max-width: 640px)');
    const orientation = window.screen.orientation as ScreenOrientation & {
      lock?: (orientation: 'landscape') => Promise<void>;
    };
    const lock = () => {
      if (!phone.matches) return;
      void orientation?.lock?.('landscape').catch(() => {
        /* A normal mobile browser may refuse locking; the portrait board remains. */
      });
    };
    lock();
    window.addEventListener('pointerdown', lock, { once: true });
    return () => {
      window.removeEventListener('pointerdown', lock);
      orientation?.unlock?.();
    };
  }, [active]);
}
